/****************************************************
 * Module Name:  memo.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from 'react';
import Constants from '../../utility/constants';
import MemoComponent from '../common/memoComponent';

const Memo = () => {
  const [local_Permission] = useState(
    Constants.USER_PERMISSION.filter(
      (iPermission) =>
        iPermission.permissionid === Constants.PERMISSIONS.OPERATION_MEMO
    )
  );

  return (
    <div>
      <MemoComponent
        isReport={false}
        hasPermission={local_Permission.length > 0}
      />
    </div>
  );
}

export default Memo;